const envConfig = 'ebankingwebuk';

const rmRegion ="rmch"

module.exports = { envConfig, rmRegion };
